module.exports = __webpack_public_path__ + "img/membership_icon.6da82c7b.png";